import { render, staticRenderFns } from "./CatalogItemPreview.vue?vue&type=template&id=676fa6e8&scoped=true&"
import script from "./CatalogItemPreview.vue?vue&type=script&lang=js&"
export * from "./CatalogItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItemPreview.vue?vue&type=style&index=0&id=676fa6e8&scoped=true&lang=css&"
import style1 from "./CatalogItemPreview.vue?vue&type=style&index=1&id=676fa6e8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676fa6e8",
  null
  
)

export default component.exports